import { configureStore } from "@reduxjs/toolkit";
import login from "./Auth/LoginSlice"
import logout from "./Auth/LogOutSlice"
import theme from "./Theme/ThemeSlice"
import settings from "./LabData/LabDataSlice"
import language from "./Language/LanguageSlice";
import profile from "./Profile/ProfileSlice";

export default configureStore({
    reducer: {
        login,
        logout,
        theme,
        settings,
        language,
        profile,
    }
})
